/**
 * Arama sonucu metinleri için ortak yardımcılar (istemci useSEO + sunucu SSR).
 * Google başlığı ~60, açıklamayı ~155-160 karakterden sonra keser; uzun metinler cümle
 * sınırından kısaltılır, kesilen cümle yarım kalmaz.
 */

export const MARKA = "AdsManager";

/**
 * Başlığa marka eki. Sondaki "— AdsManager" / "| AdsManager Blog" gibi ekler önce ayıklanır;
 * " | AdsManager" yalnızca başlık 60 karakteri aşmayacaksa geri eklenir. Google site adını ayrıca gösterir.
 */
export function tamBaslik(baslik: string): string {
  const t = baslik.replace(/\s*[|—–-]\s*AdsManager(\s+Blog)?\s*$/i, "").trim();
  if (/adsmanager/i.test(t)) return t;
  const ekli = `${t} | ${MARKA}`;
  return ekli.length > 60 ? t : ekli;
}

/** Açıklamayı en fazla `max` karaktere indirir: önce cümle sonu, olmazsa kelime sınırı + "…". */
export function kisaAciklama(metin: string, max = 158): string {
  const s = metin.replace(/\s+/g, " ").trim();
  if (s.length <= max) return s;
  const kesit = s.slice(0, max);
  const cumle = Math.max(kesit.lastIndexOf(". "), kesit.lastIndexOf("? "), kesit.lastIndexOf("! "));
  if (cumle >= 90) return kesit.slice(0, cumle + 1);
  if (/[.?!]$/.test(kesit) && kesit.length >= 90) return kesit;
  const bosluk = kesit.slice(0, max - 1).lastIndexOf(" ");
  return kesit.slice(0, bosluk > 0 ? bosluk : max - 1).replace(/[\s,;:–—-]+$/, "") + "…";
}
